import * as React from 'react'
import {Component, ReactElement} from 'react'
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,} from '@mui/material';
import {Nullable} from '../../../../app/TypeHelpers'
import {MESSAGE_TYPE} from '../../../../CodeMaster'
import {createIconWithLevel} from '../../../../styledComponents/adminPage/IconCreator'
import {LeftRowFlexContainer} from '../../../../styledComponents/FlexComponents'
import styled from 'styled-components';
import {FontSize, FontWeights} from '../../../../styledComponents/Constants';
import {StylesProvider} from '@mui/styles';

export interface DialogButtonParams {
    buttonLabel: string
    buttonHandler: (...params: any) => void
    isDefault: boolean
}

export interface DialogParams {
    title: string
    errorLevel: MESSAGE_TYPE
    message: string
    buttonProps: DialogButtonParams[]
}

interface Props {
    params: Nullable<DialogParams>
    open: boolean
}

export default class NatDialogComponent extends Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    render(): Nullable<ReactElement> {
        if (!this.props.params) {
            return null
        }

        return (<>
            <StylesProvider injectFirst>
                <Dialog
                    id={'pp-dialog'}
                    open={this.props.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                >
                    <StyledDialogTitle id="alert-dialog-title">
                        <BoldLeftRowFlexContainer style={{fontSize: '24px'}}>
                            {createIconWithLevel(this.props.params.errorLevel)}{this.props.params.title}
                        </BoldLeftRowFlexContainer>
                    </StyledDialogTitle>
                    <StyledDialogContent>
                        <StyledDialogContentText id="alert-dialog-description">
                            {this.props.params.message}
                        </StyledDialogContentText>
                    </StyledDialogContent>
                    <DialogActions>
                        {
                            this.props.params.buttonProps.map((buttonProp, index) => (
                                <StyledButton
                                    key={index}
                                    color="primary"
                                    onClick={buttonProp.buttonHandler}
                                >
                                    {buttonProp.buttonLabel}
                                </StyledButton>
                            ))
                        }
                    </DialogActions>
                </Dialog>
            </StylesProvider>
        </>)
    }
}

const StyledDialogTitle = styled(DialogTitle)`
  &.MuiDialogTitle-root > h2 {
    font-size: ${FontSize.Big};
  }

`;

const StyledDialogContent = styled(DialogContent)`
  &.MuiDialogContent-root {
    overflow-y: visible;
  }
`;

const StyledDialogContentText = styled(DialogContentText)`
  &.MuiDialogContentText-root {
    font-size: ${FontSize.Body};
    white-space: pre-line;
  }
`;

const StyledButton = styled(Button)`
  &.MuiButton-text {
    font-size: ${FontSize.Body};
  }
`;


const BoldLeftRowFlexContainer = styled(LeftRowFlexContainer)`
  font-weight: ${FontWeights.Bold};

  svg {
    font-size: ${FontSize.ExtraBig};
  }
`;

